App.controller('ReportSearchCtrl', ReportSearchCtrl);

ReportSearchCtrl.$inject = [
    'reports'
];

function ReportSearchCtrl(reports) {
    var vm = this;

    vm.search = '';
    vm.reports = reports;
}